(() => {
var $4e975982f880c932$exports = {};
const $4e975982f880c932$var$message = document.querySelector('#account-message');
const $4e975982f880c932$var$formPanel = document.querySelector('#account-form-panel');
const $4e975982f880c932$var$sessionPanel = document.querySelector('#account-session');
const $4e975982f880c932$var$signout = document.querySelector('#account-signout');
const $4e975982f880c932$var$controls = document.querySelectorAll('[data-account-mode]');
const $4e975982f880c932$var$copyRelayAddress = document.querySelector('#copy-relay-address');
const $4e975982f880c932$var$relayCopyMessage = document.querySelector('#relay-copy-message');
const $4e975982f880c932$var$relay = $4e975982f880c932$var$copyRelayAddress.dataset.relayUrl;
const $4e975982f880c932$var$client = 'runthingsnow-web';
const $4e975982f880c932$var$callback = `${location.origin}/oauth/callback`;
const $4e975982f880c932$var$transactionKey = 'backgrounder-signin';
const $4e975982f880c932$var$transactionLifetime = 600000;
const $4e975982f880c932$var$authParams = [
    'code',
    'state',
    'iss',
    'error',
    'error_description',
    'error_uri'
];
const $4e975982f880c932$var$callbackParams = new URLSearchParams(location.search);
// Keep existing OAuth returns usable without advertising website sign-in.
document.querySelector('#website-account').hidden = location.pathname !== '/oauth/callback' && !$4e975982f880c932$var$authParams.some((key)=>$4e975982f880c932$var$callbackParams.has(key));
let $4e975982f880c932$var$busy = false;
let $4e975982f880c932$var$session = null;
let $4e975982f880c932$var$renewalTimer;
function $4e975982f880c932$var$showMessage(text, error = false) {
    $4e975982f880c932$var$message.textContent = text;
    $4e975982f880c932$var$message.classList.toggle('text-danger', error);
}
function $4e975982f880c932$var$setBusy(value) {
    $4e975982f880c932$var$busy = value;
    for (const control of [
        ...$4e975982f880c932$var$controls,
        $4e975982f880c932$var$signout
    ]){
        if (control instanceof HTMLButtonElement) control.disabled = value;
        control.setAttribute('aria-disabled', String(value));
    }
    document.querySelector('.account-card').setAttribute('aria-busy', String(value));
}
function $4e975982f880c932$var$clearSession() {
    clearTimeout($4e975982f880c932$var$renewalTimer);
    $4e975982f880c932$var$session = null;
    document.querySelector('#session-email').textContent = '';
    $4e975982f880c932$var$sessionPanel.hidden = true;
    $4e975982f880c932$var$formPanel.hidden = false;
}
const $4e975982f880c932$var$base64url = (bytes)=>btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
async function $4e975982f880c932$var$startSignIn(register) {
    if ($4e975982f880c932$var$busy) return;
    if ($4e975982f880c932$var$session) {
        document.querySelector('#website-account').scrollIntoView();
        return;
    }
    $4e975982f880c932$var$setBusy(true);
    $4e975982f880c932$var$showMessage('Opening secure sign-in...');
    try {
        const state = $4e975982f880c932$var$base64url(crypto.getRandomValues(new Uint8Array(32)));
        const verifier = $4e975982f880c932$var$base64url(crypto.getRandomValues(new Uint8Array(32)));
        const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
        sessionStorage.setItem($4e975982f880c932$var$transactionKey, JSON.stringify({
            state: state,
            verifier: verifier,
            relay: $4e975982f880c932$var$relay,
            client: $4e975982f880c932$var$client,
            callback: $4e975982f880c932$var$callback,
            createdAt: Date.now()
        }));
        const query = new URLSearchParams({
            response_type: 'code',
            client_id: $4e975982f880c932$var$client,
            redirect_uri: $4e975982f880c932$var$callback,
            state: state,
            code_challenge_method: 'S256',
            code_challenge: $4e975982f880c932$var$base64url(new Uint8Array(digest))
        });
        if (register) query.set('screen', 'register');
        location.assign(`${$4e975982f880c932$var$relay}/oauth/authorize?${query}`);
    } catch  {
        $4e975982f880c932$var$showMessage('Could not start secure sign-in. Enable browser session storage and use a browser with secure cryptography support, then try again.', true);
        $4e975982f880c932$var$setBusy(false);
        document.querySelector('#website-account').scrollIntoView();
    }
}
async function $4e975982f880c932$var$request(endpoint, fields) {
    let response;
    try {
        response = await fetch(`${$4e975982f880c932$var$relay}/oauth/${endpoint}`, {
            method: 'POST',
            credentials: 'omit',
            cache: 'no-store',
            referrerPolicy: 'no-referrer',
            redirect: 'error',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams({
                client_id: $4e975982f880c932$var$client,
                ...fields
            }),
            signal: AbortSignal.timeout(20000)
        });
    } catch  {
        throw new Error('Could not reach the sign-in service. Check your connection and start a new sign-in; this request will not be retried.');
    }
    if (!response.ok) throw new Error(response.status >= 500 ? 'The sign-in service is unavailable. Please start a new sign-in later.' : 'The sign-in service refused the request. Please start a new sign-in.');
    if (endpoint === 'revoke') return;
    try {
        return await response.json();
    } catch  {
        throw new Error('The sign-in service returned an unreadable response. Please start a new sign-in.');
    }
}
function $4e975982f880c932$var$acceptTokens(data, expectedAccount) {
    if (!data || typeof data.access_token !== 'string' || !data.access_token || typeof data.refresh_token !== 'string' || !data.refresh_token || typeof data.token_type !== 'string' || data.token_type.toLowerCase() !== 'bearer' || !Number.isSafeInteger(data.expires_in) || data.expires_in <= 0 || data.expires_in > 2147483 || typeof data.email !== 'string' || !data.email || typeof data.accountId !== 'string' || !data.accountId || expectedAccount && expectedAccount !== data.accountId) throw new Error('The sign-in service returned an invalid session. Please start a new sign-in.');
    // Tokens never leave this tab's memory. The response identifies the account;
    // it does not authorize access to any Mac or protected website API.
    $4e975982f880c932$var$session = {
        accessToken: data.access_token,
        refreshToken: data.refresh_token,
        accountId: data.accountId,
        email: data.email
    };
    document.querySelector('#session-email').textContent = $4e975982f880c932$var$session.email;
    $4e975982f880c932$var$formPanel.hidden = true;
    $4e975982f880c932$var$sessionPanel.hidden = false;
    const lifetime = data.expires_in * 1000;
    clearTimeout($4e975982f880c932$var$renewalTimer);
    $4e975982f880c932$var$renewalTimer = setTimeout($4e975982f880c932$var$renewSession, lifetime - Math.min(60000, lifetime / 10));
}
async function $4e975982f880c932$var$renewSession() {
    if (!$4e975982f880c932$var$session) return;
    $4e975982f880c932$var$setBusy(true);
    const { refreshToken: refreshToken, accountId: accountId } = $4e975982f880c932$var$session;
    // Retire before sending: replaying a rotated token revokes its whole family.
    $4e975982f880c932$var$session.refreshToken = null;
    try {
        const data = await $4e975982f880c932$var$request('token', {
            grant_type: 'refresh_token',
            refresh_token: refreshToken
        });
        $4e975982f880c932$var$acceptTokens(data, accountId);
    } catch (error) {
        $4e975982f880c932$var$clearSession();
        $4e975982f880c932$var$showMessage(`Your browser session has ended. ${error.message}`, true);
    } finally{
        $4e975982f880c932$var$setBusy(false);
    }
}
async function $4e975982f880c932$var$finishSignIn() {
    const params = new URLSearchParams(location.search);
    if (!$4e975982f880c932$var$authParams.some((key)=>params.has(key))) return;
    $4e975982f880c932$var$setBusy(true);
    // Strip credentials before rendering results or making any network request.
    const clean = new URL(location.href);
    $4e975982f880c932$var$authParams.forEach((key)=>clean.searchParams.delete(key));
    history.replaceState(null, '', `${clean.pathname}${clean.search}#website-account`);
    try {
        const stored = sessionStorage.getItem($4e975982f880c932$var$transactionKey);
        sessionStorage.removeItem($4e975982f880c932$var$transactionKey);
        let saved;
        try {
            saved = JSON.parse(stored);
        } catch  {
            throw new Error('The saved sign-in request is unreadable. Please start a new sign-in.');
        }
        if (!saved || saved.relay !== $4e975982f880c932$var$relay || saved.client !== $4e975982f880c932$var$client || saved.callback !== $4e975982f880c932$var$callback || location.pathname !== '/oauth/callback' || !Number.isSafeInteger(saved.createdAt) || Date.now() < saved.createdAt || Date.now() - saved.createdAt > $4e975982f880c932$var$transactionLifetime || !/^[A-Za-z0-9_-]{43}$/.test(saved.state) || !/^[A-Za-z0-9_-]{43}$/.test(saved.verifier) || params.get('state') !== saved.state || params.get('iss') !== $4e975982f880c932$var$relay || $4e975982f880c932$var$authParams.some((key)=>params.getAll(key).length > 1) || params.has('code') === params.has('error')) throw new Error('This sign-in response is invalid or expired. Please start a new sign-in.');
        if (params.has('error')) {
            const errors = {
                access_denied: 'Sign-in was cancelled. You can try again when ready.',
                account_deleted: 'Your account was deleted.',
                account_updated: 'Your account settings were updated. Log in again to continue.'
            };
            $4e975982f880c932$var$showMessage(Object.hasOwn(errors, params.get('error')) ? errors[params.get('error')] : 'Sign-in was not completed. Please try again.');
            return;
        }
        const code = params.get('code');
        if (!code) throw new Error('The sign-in code is missing. Please start a new sign-in.');
        $4e975982f880c932$var$showMessage('Completing sign-in...');
        const data = await $4e975982f880c932$var$request('token', {
            grant_type: 'authorization_code',
            redirect_uri: $4e975982f880c932$var$callback,
            code: code,
            code_verifier: saved.verifier
        });
        $4e975982f880c932$var$acceptTokens(data);
        $4e975982f880c932$var$showMessage('You are logged in.');
    } catch (error) {
        $4e975982f880c932$var$clearSession();
        $4e975982f880c932$var$showMessage(error instanceof DOMException ? 'Could not read the saved sign-in request. Enable browser session storage and try again.' : error.message, true);
    } finally{
        $4e975982f880c932$var$setBusy(false);
        document.querySelector('#website-account').scrollIntoView();
    }
}
$4e975982f880c932$var$controls.forEach((control)=>control.addEventListener('click', (event)=>{
        event.preventDefault();
        $4e975982f880c932$var$startSignIn(control.dataset.accountMode === 'register');
    }));
$4e975982f880c932$var$signout.addEventListener('click', async ()=>{
    if ($4e975982f880c932$var$busy || !$4e975982f880c932$var$session) return;
    const refreshToken = $4e975982f880c932$var$session.refreshToken;
    $4e975982f880c932$var$clearSession();
    $4e975982f880c932$var$setBusy(true);
    $4e975982f880c932$var$showMessage('Logging out...');
    try {
        await $4e975982f880c932$var$request('revoke', {
            token: refreshToken,
            token_type_hint: 'refresh_token'
        });
        $4e975982f880c932$var$showMessage('Logged out. Your Mac and other devices remain signed in.');
    } catch (error) {
        $4e975982f880c932$var$showMessage(`Logged out of this page, but the service session could not be revoked. It will expire automatically. ${error.message}`, true);
    } finally{
        $4e975982f880c932$var$setBusy(false);
    }
});
$4e975982f880c932$var$copyRelayAddress.disabled = false;
$4e975982f880c932$var$copyRelayAddress.addEventListener('click', async ()=>{
    $4e975982f880c932$var$copyRelayAddress.disabled = true;
    $4e975982f880c932$var$relayCopyMessage.textContent = '';
    $4e975982f880c932$var$relayCopyMessage.classList.remove('text-danger');
    try {
        await navigator.clipboard.writeText($4e975982f880c932$var$relay);
        $4e975982f880c932$var$relayCopyMessage.textContent = 'Relay address copied. Paste it into Settings > Relay Account in Backgrounder.';
    } catch  {
        $4e975982f880c932$var$relayCopyMessage.textContent = 'Could not copy the relay address. Check your browser clipboard permissions and try again.';
        $4e975982f880c932$var$relayCopyMessage.classList.add('text-danger');
    } finally{
        $4e975982f880c932$var$copyRelayAddress.disabled = false;
    }
});
window.addEventListener('pageshow', (event)=>{
    if (event.persisted) {
        $4e975982f880c932$var$clearSession();
        $4e975982f880c932$var$setBusy(false);
        $4e975982f880c932$var$showMessage('This page was restored. Log in again to continue.');
    }
});
$4e975982f880c932$var$setBusy(false);
$4e975982f880c932$var$finishSignIn();

})();
//# sourceMappingURL=index.98a985d4.js.map
